<div class="contact-picker">

  @if (isCollapsible()) {
    <!-- ── Collapsible mode (large lists) ── -->
    <div class="contact-picker__header">
      <p class="contact-picker__label">{{ label }} ({{ contacts.length }} contacts)</p>
      <button type="button" class="contact-picker__toggle"
        (click)="toggleCollapse()"
        [attr.aria-expanded]="!isCollapsed()">
        {{ isCollapsed() ? 'Show ' + contacts.length + ' contacts' : 'Collapse' }}
        <i class="pi" [class.pi-chevron-down]="isCollapsed()" [class.pi-chevron-up]="!isCollapsed()" aria-hidden="true"></i>
      </button>
    </div>

    @if (!isCollapsed()) {
      <div class="contact-picker__search-wrap">
        <i class="pi pi-search contact-picker__search-icon" aria-hidden="true"></i>
        <input
          type="text"
          class="contact-picker__search"
          placeholder="Search by name, email, or title…"
          [value]="searchQuery()"
          (input)="onSearch($event)"
          aria-label="Search contacts" />
      </div>

      <div class="contact-picker__grid">
        @for (contact of filteredContacts; track contact.id) {
          <button type="button" class="contact-card"
            [disabled]="disabled"
            (click)="onSelect(contact)"
            [attr.aria-label]="'Select ' + displayName(contact)">
            <span class="contact-card__name">{{ displayName(contact) }}</span>
            @if (contact.title) {
              <span class="contact-card__title">{{ contact.title }}</span>
            }
            @if (contact.email) {
              <span class="contact-card__email">{{ contact.email }}</span>
            }
          </button>
        }
        @if (filteredContacts.length === 0) {
          <p class="contact-picker__no-results">No contacts match your search.</p>
        }
      </div>
    }

  } @else {
    <!-- ── Simple mode (small lists) ── -->
    <p class="contact-picker__label">{{ label }}</p>
    <div class="contact-picker__grid">
      @for (contact of contacts; track contact.id) {
        <button type="button" class="contact-card"
          [disabled]="disabled"
          (click)="onSelect(contact)"
          [attr.aria-label]="'Select ' + displayName(contact)">
          <span class="contact-card__name">{{ displayName(contact) }}</span>
          @if (contact.title) {
            <span class="contact-card__title">{{ contact.title }}</span>
          }
          @if (contact.email) {
            <span class="contact-card__email">{{ contact.email }}</span>
          }
        </button>
      }
    </div>
  }

</div>
